import(/* webpackMode: "eager", webpackExports: ["StakingProjectClient"] */ "/codebuild/output/src3540671299/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/staking/[id]/StakingProjectClient.tsx");
